interface ProgressBarProps {
  min: number;
  max: number;
  progress: number;
  label: string;
}

const ProgressBar = ({
  min,
  max,
  progress,
  label,
}: ProgressBarProps): React.JSX.Element => {
  const barWidth = (progress / max) * 100;

  return (
    <div
      className="signup-modal__progress"
      role="progressbar"
      aria-label={label}
      aria-valuetext={`Steg ${progress} av ${max}`}
      aria-valuenow={progress}
      aria-valuemin={min}
      aria-valuemax={max}
    >
      <div
        className="signup-modal__progress-bar"
        style={{ width: `${barWidth}%` }}
      />
    </div>
  );
};

export default ProgressBar;
